// @ts-expect-error notype
import { gql } from 'graphql-request';

export const allPropertiesForCompanyIdsQueryDocument = gql`
    query findAllPropertiesByCompanyIdsQuery($body: PropertiesByCompanyIdsGraphQLDto!, $count: Int!, $page: Int!, $query: String) {
        findAllPropertiesByCompanyIds(body: $body, count: $count, page: $page, query: $query) {
            properties {
                propertyId
                description
                webPageUrl
                webPageId
                title
                imageUrls
                aiScore
                details {
                    propertyType
                    listingType
                    price
                    sizeLand
                    sizePlot
                    sizeLiving
                    features
                    currency
                    bedrooms
                    bathrooms
                    availability
                    amenities
                    energyCertRating
                    hasPool
                    poolSize
                    furnished
                    needsRenovation
                    floorsCount
                    floorNumber
                    totalFloors
                    elevator
                    kitchen
                    kitchenType
                    livingAreaExternal
                    gardenDescription
                    gardenSize
                    parkingTypes
                    parkingMonthlyCosts
                    terraceTypes
                    terraceSizes
                    constructionYear
                    energyCertAvailable
                    pricePerSquareMeter
                    heatingType
                    hasAC
                    hasSolar
                    hasElectricityLine
                    underConstruction
                }
                createdAt
                companyName
                address {
                    Country
                    City
                    State
                    StreetAddress
                    Neighborhood
                }
            }
            total
        }
    }
`;
